module.exports = __webpack_public_path__ + "static/media/zulick89.1ff9c14e.png";